export function toExtension(filename) {
  return filename.split(".").pop();
}
